import { createResource } from 'react-resource-router';

import { type ResourceDependencies } from '../../../common/types';

import { getSchedulesEndpoint } from './endpoints';

export const createSchedulesResource = (
	checkConsolidationOnRouteDependency?: (dependencies: ResourceDependencies) => Promise<boolean>,
	depends?: string[],
) =>
	createResource({
		type: 'schedulesResource',
		getKey: () => 'schedulesResource',
		getData: async ({ dependencies }) => {
			const isConsolidated = checkConsolidationOnRouteDependency
				? await checkConsolidationOnRouteDependency(dependencies as ResourceDependencies)
				: true;

			if (!isConsolidated) {
				return null;
			}

			return getSchedulesEndpoint();
		},
		isBrowserOnly: true,
		depends,
	});
